<template>
    <zm-button
      data-testid="checkout-button-478"
      :data-url='targetUrl'
      size='lg'
      type="primary"
      @click="handleClick"
    >
      {{ ctaName }}
    </zm-button>
</template>

<script>
import setupMixin from "@/views/success/mixin/set-up";
import { mapGetters } from 'vuex';
import { plansof } from '@/utils/chain';
import { planTypes } from '@/common/constants';
import { translateToEn } from '@/plugins/i18n';
import { navigateToTargetPage } from '@/utils/modal-utils.js'
import { sendGAbizInfo } from '@/views/checkout/utils'
import { getEmailCTAsTrackingUrl, UTM_CONTENT_CODE } from '@/views/succezz/utils/email-ctas-tracking';

export default {
  mixins: [setupMixin],
  props: {
    showExplore: Boolean,
  },
  computed: {
    ...mapGetters(['boughtPlans']),
    isSetUpZPCTA() {
      return plansof(this.boughtPlans).type(planTypes.ZOOM_ONE_BUNDLE, planTypes.ZONE_PRO_PLUS,planTypes.ZOOM_PHONE,planTypes.ZOOM_PHONE$ZPA,planTypes.ZOOM_PHONE$ZPI).has();
    },
    ctaName() {
      if (this.companySetupZoomOneName) {
        return this.companySetupZoomOneName;
      } else if (this.isSetUpZPCTA) {
        return this.$t('billing.success.get_started');
      } else {
        return this.$t('billing.success.confirmation.view_my_plan');
      }
    },
    ctaEnName() {
      if (this.companySetupZoomOneName) {
        return this.companySetupZoomOneEnName;
      } else if (this.isSetUpZPCTA) {
        return translateToEn('billing.success.get_started');
      } else {
        return translateToEn('billing.success.confirmation.view_my_plan');
      }
    },
    targetUrl() {
      let targetURL = '';
      if (this.companySetupZoomOneName) {
        targetURL = getEmailCTAsTrackingUrl('/setup-guide', { utmContent: this.setUpButtonUtmContentForTracking });
      } else if (this.isSetUpZPCTA) {
        targetURL = getEmailCTAsTrackingUrl('/pbx/page/telephone/new', { utmContent: UTM_CONTENT_CODE.setUpZoomPhone }, '?p=new&');
      } else {
        targetURL = getEmailCTAsTrackingUrl('/billing', { utmContent: UTM_CONTENT_CODE.viewMyPlan });
      }
      return targetURL;
    }
  },
  methods: {
    handleClick() {
      sendGAbizInfo('purchase confirmation', this.ctaEnName?.toLowerCase?.())
      if (this.companySetupZoomOneName) {
        // Skip tracking in goCompanySetup since we already sent tracking above
        this.goCompanySetup('/setup-guide', true);
      } else if (this.isSetUpZPCTA) {
        // Use unified navigation util - automatically handles modal context and origin
        navigateToTargetPage('/pbx/page/telephone/new?p=new');
      } else {
        // Use unified navigation util - automatically handles modal context and origin
        navigateToTargetPage('/billing');
      }
    }
  }
}
</script>

<style lang="scss">

</style>
